import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs';
import { AuthenticationService } from '../../services/AuthenticationService';

@Component({ standalone: false,
  selector: 'app-mfa-dialog',
  templateUrl: 'mfa-dialog.component.html',
  styleUrls: ['mfa-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class MFADialogComponent {
  public userId!:string;
  public title: string= "Title";
  public message: string = "";
  public confirmButtonText = "Yes";
  public cancelButtonText = "Cancel";
  public busy:boolean=false;

  public manualEntryKey?: string;
  public qrCodeSetupImageUrl?: string; //Base64-encoded PNG image

  public dialogForm: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<MFADialogComponent>, private authService:AuthenticationService, public snackBar: MatSnackBar) {
    this.dialogForm = new FormGroup({
      code: new FormControl('', [Validators.required]),
    });
    if(data){
        this.title=data.title;
        this.message = data.message || this.message;
        if (data.buttonText) {
            this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
            this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        }
        this.userId = data.userId
        this.manualEntryKey = data.manualEntryKey;
        this.qrCodeSetupImageUrl = data.qrCodeSetupImageUrl;
    }
  }

  onConfirmClick(): void {
    this.busy=true;
    this.authService.validateTwoFactor(this.userId, this.dialogForm.get('code')!.value).pipe(take(1)).subscribe(r=>{
      //if validation successful => close dialog and let calling component proceed as desired
      this.busy=false;
      if(r.success) this.dialogRef.close(true);
      else this.snackBar.open("Invalid code", '×', { panelClass: ['warn-snackbar'], verticalPosition: 'top' });
    });
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

}